<template>
  <div>
    <ListaUsuarios
      :atividade="atividade"
      v-if="pesquisar_usuarios"
      @voltar="
        getUsuarios();
        pesquisar_usuarios = false;
      "
    />

    <div class="row animate__animated animate__fadeIn" v-else>
      <div class="col-md-12">
        <div class="d-flex">
          <div class="mr-auto">
            <h3 class="mb-3 text-gray-800">
              {{ $t("Usuários Inscritos") }}
            </h3>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex">
          <div class="mr-auto">
            <button
              class="btn btn-sm btn-primary"
              @click="pesquisar_usuarios = true"
            >
              <i class="fas fa-plus-square" />
              {{ $t("Vincular Usuário") }}
            </button>
          </div>
          <div>
            <div class="input-group mb-3">
              <b-input
                :placeholder="$t('Type to search')"
                class="form-control search-input"
                type="text"
                v-model="search"
                v-on:change="getUsuarios(null)"
                aria-describedby="input-search"
              />
              <div class="input-group-append" role="button">
                <span class="input-group-text" id="input-search"
                  ><i class="fas fa-search search-icon"
                /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <span>
          <a v-if="!showName" @click.prevent="mostrarNome" href="#"
            ><i class="fas fa-eye"></i> Mostrar Nome de Registro</a
          >
          <a v-else @click.prevent="ocultarNome" href="#"
            ><i class="fas fa-eye-slash"></i> Ocultar Nome de Registro</a
          >
        </span>
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />
        <b-table
          :fields="[
            {
              key: 'atividade',
              label: $t('Detalhes'),
            },
            {
              key: 'cadastrado',
              label: $t('Inscrito em'),
            },
            {
              key: 'status',
              label: $t('Status'),
            },
            {
              key: 'actions',
              label: '',
              class: 'text-right',
              thStyle: { width: '200px', minWidth: '200px' },
            },
          ]"
          :items="UsuarioList"
          :responsive="true"
          striped
          hover
          show-empty
          small
          outlined
          stacked="md"
          table-class="mb-3"
        >
          <template v-slot:cell(atividade)="data">
            Usuário:
            <strong v-if="data.item.usuario">
              <b v-if="!data.item.usuario.nome_social">{{
                data.item.usuario.nome_completo
              }}</b>
              <b v-else
                >{{ data.item.usuario.nome_social }} ( N.R.: )
                <span v-if="showName">{{
                  data.item.usuario.nome_completo
                }}</span>
              </b>
              <b-link
                :to="'/dashboard/usuario/edit/' + data.item.usuario.id"
                target="_blank"
              >
                <i class="fas fa-external-link-alt"></i>
              </b-link>
            </strong>
            <br />
            Filiação 1:
            <strong v-if="data.item.usuario">
              {{ data.item.usuario.mae }}
            </strong>
            <br />
            Data de Nascimento:
            <b>{{ data.item.usuario.data_nascimento | formatDate }}</b>
            <br />
            Idade:
            <b>{{ data.item.usuario.data_nascimento | calcIdade }} ano(s)</b>
            <br />
            Família:
            <strong v-if="data.item.usuario">
              <span v-if="data.item.familia.codigo_familiar">
                Código Cadúnico:
                {{ data.item.familia.codigo_familiar }}
              </span>
              <span v-else>ID{{ data.item.familia.id }}</span>
              <b-link
                :to="'/dashboard/familias/edit/' + data.item.familia.id"
                target="_blank"
              >
                <i class="fas fa-external-link-alt"></i>
              </b-link>
            </strong>
            <br />
          </template>
          <template v-slot:cell(cadastrado)="data">
            <strong>{{ data.value }}</strong>
          </template>
          <template v-slot:cell(status)="data">
            <span v-html="data.item.status_nome"></span>
          </template>

          <template v-slot:cell()="data">
            <b-button
              title="Confirmar Presença"
              @click.prevent="confirmarPresenca(data.item.id)"
              class="px-2 mb-0 btn-presenca"
              data-style="zoom-in"
              variant="success"
              size="xs"
              type="button"
              v-b-tooltip.hover
              :id="'btnpresencao' + data.item.id"
              v-if="data.item.presenca == 0"
              :disabled="
                atividade.status_sem_formatacao == 'REALIZADO' ? false : true
              "
            >
              <i class="fas fa-check"></i>
            </b-button>
            <b-button
              title="Cancelar Confirmação de Presença"
              @click.prevent="confirmarPresenca(data.item.id)"
              class="px-2 mb-0 btn-presenca"
              data-style="zoom-in"
              variant="warning"
              size="xs"
              type="button"
              v-b-tooltip.hover
              :id="'btnpresencao' + data.item.id"
              v-else
              :disabled="
                atividade.status_sem_formatacao == 'REALIZADO' ? false : true
              "
            >
              <i class="fas fa-ban"></i>
            </b-button>

            <span
              v-if="
                atividade.status_sem_formatacao != 'FINALIZADO' &&
                atividade.status_sem_formatacao != 'INATIVO' &&
                atividade.status_sem_formatacao != 'CANCELADO'
              "
            >
              <b-button
                :title="$t('Desvincular')"
                @click.prevent="desvincular(data.item.id)"
                class="px-2 mb-0 btn-desvincular"
                variant="danger"
                size="xs"
                data-style="zoom-in"
                type="button"
                v-b-tooltip.hover
                :id="'btndesvincular' + data.item.id"
                :disabled="data.item.presenca == 1 ? true : false"
              >
                <i class="fas fa-unlink"></i>
              </b-button>
            </span>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />
              <h3 class="bold">{{ $t("No records found") }}</h3>
            </div>
          </template>
        </b-table>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="getUsuarios"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }}
              de
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListaUsuarios from "./ListaUsuarios";
export default {
  name: "ListaUsuariosInscritos",
  props: ["atividade", "desvinculados"],
  components: {
    ListaUsuarios,
  },
  data() {
    return {
      showName: false,
      pesquisar_usuarios: false,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      UsuarioList: [],
      usuario: null,
      item: {
        usuario_id: null,
        atividade_id: null,
      },
    };
  },

  mounted() {
    this.getUsuarios();
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    confirmarPresenca(id) {
      let ladda = Ladda.create(document.getElementById("btnpresencao" + id));
      ladda.start();

      axios
        .put(`api/dashboard/atividadesvinculo/${id}`)
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .finally(() => {
          ladda.stop();
          this.getUsuarios();
        });
    },
    usuarioSelecionado(usuario) {
      this.usuario = usuario;
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getUsuarios();
      }
    },
    getUsuarios() {
      this.loading = true;
      axios
        .get("api/dashboard/atividadesvinculo", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            atividade: this.atividade.id,
          },
        })
        .then((response) => {
          this.UsuarioList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getUsuarios();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    desvincular(id) {
      let ladda = Ladda.create(document.getElementById("btndesvincular" + id));
      ladda.start();

      axios
        .delete(`api/dashboard/atividadesvinculo/${id}`)
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .finally(() => {
          ladda.stop();
          this.getUsuarios();
          this.$root.$emit("usuariodesvinculado");
        });
    },
  },
};
</script>

<style></style>
